import { createWebAnalytics, type AnalyticsClient } from 'analytics/web';
import { apiConfig } from './api-config';

export type { EventName } from 'analytics/web';

const APP_VERSION = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev';

export const analytics: AnalyticsClient = createWebAnalytics({
  apiUrl: apiConfig.baseUrl,
  appVersion: APP_VERSION,
  // Web is on wifi and isn't battery-sensitive — keep the buffer short so
  // events land within a few seconds of the user's action.
  flushIntervalMs: 5_000,
  flushBatchSize: 5,
});
